import { render } from "./ListComp.vue?vue&type=template&id=37c4eae6&scoped=true"
import script from "./ListComp.vue?vue&type=script&lang=js"
export * from "./ListComp.vue?vue&type=script&lang=js"

import "./ListComp.vue?vue&type=style&index=0&id=37c4eae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c4eae6"]])

export default __exports__